import { SearchFilters } from '../query-variables';

export const buildSkipConditions = (filters: SearchFilters, fixedTypes: string[]) => {
  const types = filters.contentTypes || [];

  const shouldSkipAllQueries =
    !filters.searchTerm && !filters.keyStages?.length && !filters.traits?.length && !types.length;

  return {
    queries: shouldSkipAllQueries,
    missions: types.length > 0 && !types.includes('Missions'),
    programmes: types.length > 0 && !types.includes('Programmes'),
    courses:
      (types.length > 0 && !types.includes('Courses')) ||
      (filters.keyStages && filters.keyStages.length > 0 && !types.includes('Courses')) ||
      (filters.traits && filters.traits.length > 0 && !types.includes('Courses')) ||
      false,
    resources:
      (filters.keyStages && filters.keyStages.length > 0) ||
      (types.length > 0 && types.every((type) => fixedTypes.includes(type))),
  };
};
